import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Target, Share2, TrendingUp, Users, Search, BarChart3, Code, Layout, Lightbulb } from 'lucide-react';

const services = [
  {
    icon: Target,
    title: 'Marketing Strategy',
    items: [
      'Brand Strategy',
      'Brand Messaging',
      'Competition Analysis',
      'Go-to-market Strategy',
      'CMO For Hire'
    ]
  },
  {
    icon: Share2,
    title: 'Content Marketing & Social Media',
    items: [
      'Social Media Content',
      'Influencer Marketing',
      'Email Marketing',
      'Content Strategy',
      'Blogs & Testimonials'
    ]
  },
  {
    icon: TrendingUp,
    title: 'Performance Marketing',
    items: [
      'Google Adwords',
      'Meta Ads Campaigns',
      'TikTok Ads',
      'LinkedIn Advertising',
      'Conversion Tracking'
    ]
  },
  {
    icon: Users,
    title: 'Lead Generation & CRM',
    items: [
      'Buyer Journey Mapping',
      'Content Strategy',
      'CRM-Built Marketing',
      'Lead Generation',
      'Marketing Automation'
    ]
  },
  {
    icon: Search,
    title: 'SEO & Search Marketing',
    items: [
      'Keyword Analysis',
      'Competition Analysis',
      'On-page Optimization',
      'Off-page Optimization',
      'SEO Performance Report',
      'AI Search Optimisation'
    ]
  },
  {
    icon: BarChart3,
    title: 'Tracking and Analytics',
    items: [
      'Campaign Performance Tracking',
      'Conversion Rate Optimization',
      'User Behaviour Analytics',
      'Product Analytics Set-up'
    ]
  },
  {
    icon: Code,
    title: 'Web Development',
    items: [
      'Custom Website Design and Development',
      'E-Commerce Website Development',
      'Web Application Development',
      'Content Management Systems (CMS)',
      'Website Maintenance and Support'
    ]
  },
  {
    icon: Layout,
    title: 'UI and UX Audit',
    items: [
      'User Experience (UX) Evaluation',
      'User Interface (UI) Design Assessment',
      'Accessibility and Inclusivity Review',
      'Performance and Usability Analysis',
      'Competitor Analysis and Benchmarking'
    ]
  },
  {
    icon: Lightbulb,
    title: 'Strategy and Branding',
    items: [
      'Brand Identity Development',
      'Market Research and Analysis',
      'Brand Strategy Development',
      'Digital Marketing Strategy',
      'Brand Experience Design'
    ]
  }
];

const Services = () => {
  return (
    <section id="services" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900">
            Growth <span className="text-blue-600">Services</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We help you scale right by employing channels that convert
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <Card
                key={index}
                className="border-blue-100 hover:border-blue-300 hover:shadow-xl transition-all duration-300 group cursor-pointer bg-white"
              >
                <CardHeader>
                  <div className="mb-4 inline-block p-3 bg-blue-50 rounded-lg group-hover:bg-blue-100 transition-colors duration-300">
                    <Icon className="w-8 h-8 text-blue-600" />
                  </div>
                  <CardTitle className="text-xl font-bold text-gray-900 group-hover:text-blue-600 transition-colors">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-2">
                    {service.items.map((item, idx) => (
                      <li key={idx} className="flex items-start text-gray-600">
                        <span className="text-blue-600 mr-2">•</span>
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;